import { useContext } from 'react';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { loan_application_api } from '@axo/shared/data-access/api';
import { useQuery } from 'react-query';
import {
  loanApplicationDocumentsKeys,
  parseLoanApplicationDocumentsKeys
} from '../cache-keys/loanApplicationDocumentsKeys';
import { queryFunction } from '../query-function';

export function useLoanApplicationDocument(
  applicationID: string | undefined | null,
  documentID: string | undefined | null
) {
  const { state } = useContext(DataAccessContext);
  const api = useAPI();
  const cacheKey = loanApplicationDocumentsKeys.document({
    applicationID: applicationID ?? '',
    documentID: documentID ?? '',
  });

  return useQuery(
    cacheKey,
    queryFunction(
      loan_application_api.getLoanApplicationDocument(api),
      ({ queryKey }) => ({
        applicationID: parseLoanApplicationDocumentsKeys(queryKey).applicationID ?? '',
        documentID: parseLoanApplicationDocumentsKeys(queryKey).documentID ?? '',
      })
    ),
    { enabled: !!state.user.token && !!applicationID && !!documentID }
  );
}
